<template>
  <component :is="to ? 'router-link' : 'button'" class="project-experience-action index-ignore" :to="to" :type="to ? undefined : 'button'">
    <span><slot /></span><ArrowUpRightIcon />
  </component>
</template>

<script>
import ArrowUpRightIcon from './ArrowUpRightIcon.vue';
export default {
  components: { ArrowUpRightIcon },
  props: { to: { type: [String, Object], default: undefined } },
};
</script>

<style scoped>
.project-experience-action{display:inline-flex;align-items:center;gap:.6rem;min-height:40px;box-sizing:border-box;padding:.35rem 0;border:0;background:none;color:var(--site-text-secondary);font:400 .83rem/1.5 'Quattrocento Sans',sans-serif;text-decoration:none;cursor:var(--site-interactive-cursor,pointer);transition:color 160ms ease,transform 160ms cubic-bezier(.22,1,.36,1)}
.project-experience-action>.site-arrow-up-right{width:13px;height:13px;transition:transform 180ms cubic-bezier(.22,1,.36,1)}
.project-experience-action:focus-visible{outline:1px solid currentColor;outline-offset:4px}
.project-experience-action:active{transform:translateY(1px)}
@media(hover:hover) and (pointer:fine){.project-experience-action:hover{color:var(--site-text-primary)}.project-experience-action:hover>.site-arrow-up-right{transform:translate(2px,-2px)}}
@media(pointer:coarse){.project-experience-action{min-height:44px}}
@media(prefers-reduced-motion:reduce){.project-experience-action,.project-experience-action>.site-arrow-up-right{transition:none;transform:none!important}}
</style>
